import { CustomerAddressType } from '../enums';

export class AddCustomerAddressInput {
    public districtId: number = 0;
    public postalCode: string = '';
    public description: string = '';
    public customerAddressType: CustomerAddressType = CustomerAddressType.BillingAddress;
}
